import api from './api';

export interface ClassificacaoServico {
  id?: string;
  descricao: string;
  nome: string;
  index: number;
  nivel: number;
  classificacaoServicoPaiId: string | null;
}

export const getAll = () => api.get<ClassificacaoServico[]>('classificacaoServico');
export const update = (value: any) => api.put('classificacaoServico', value);
export const excluir = (id: string) => api.delete(`classificacaoServico/${id}`);
export const getClassificacaoServicoForOptions = (id?: string) =>
  api
    .get(`classificacaoServico/getSubItens/${id}`)
    .then(classificacoes => (classificacoes || []).map(c => ({ text: c.nome, value: c.id.toString() })));
